import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/theme";
import { AuthProvider } from "@/context/AuthContext";
import { ProgressProvider } from "@/context/ProgressContext";
import { RequireAuth, RequireAdmin, TabLayout } from "@/components/Layout";

import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";

import Home from "@/pages/Home";
import Training from "@/pages/Training";
import Content from "@/pages/Content";
import Crystals from "@/pages/Crystals";
import HQ from "@/pages/HQ";

import ModulePage from "@/pages/ModulePage";
import LessonPage from "@/pages/LessonPage";
import CrystalDetail from "@/pages/CrystalDetail";
import Library from "@/pages/school/Library";
import Basics from "@/pages/school/Basics";
import Wrong from "@/pages/school/Wrong";
import Intentions from "@/pages/school/Intentions";
import Favourites from "@/pages/school/Favourites";
import LabHome from "@/pages/LabHome";
import LabDetail from "@/pages/LabDetail";

import Affiliates from "@/pages/admin/AdminAffiliates";
import AdminContent from "@/pages/admin/AdminContentList";
import ContentEdit from "@/pages/admin/AdminContentEdit";
import AdminCrystals from "@/pages/admin/AdminCrystalsList";
import CrystalEdit from "@/pages/admin/AdminCrystalEdit";
import AdminLab from "@/pages/admin/AdminLabList";
import LabEdit from "@/pages/admin/AdminLabEdit";
import LabLanding from "@/pages/admin/AdminLabLanding";
import Shopify from "@/pages/admin/AdminShopify";

function Protected({ children }) {
  return <RequireAuth>{children}</RequireAuth>;
}
function Admin({ children }) {
  return (
    <RequireAuth>
      <RequireAdmin>{children}</RequireAdmin>
    </RequireAuth>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ProgressProvider>
          <Toaster position="top-center" richColors />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />

              <Route element={<Protected><TabLayout /></Protected>}>
                <Route path="/" element={<Home />} />
                <Route path="/training" element={<Training />} />
                <Route path="/content" element={<Content />} />
                <Route path="/crystals" element={<Crystals />} />
                <Route path="/hq" element={<HQ />} />
              </Route>

              <Route path="/module/:id" element={<Protected><ModulePage /></Protected>} />
              <Route path="/lesson/:id" element={<Protected><LessonPage /></Protected>} />
              <Route path="/crystal/:slug" element={<Protected><CrystalDetail /></Protected>} />
              <Route path="/crystal-school/library" element={<Protected><Library /></Protected>} />
              <Route path="/crystal-school/basics" element={<Protected><Basics /></Protected>} />
              <Route path="/crystal-school/wrong" element={<Protected><Wrong /></Protected>} />
              <Route path="/crystal-school/intentions" element={<Protected><Intentions /></Protected>} />
              <Route path="/crystal-school/favourites" element={<Protected><Favourites /></Protected>} />
              <Route path="/lab" element={<Protected><LabHome /></Protected>} />
              <Route path="/lab/:slug" element={<Protected><LabDetail /></Protected>} />

              <Route path="/admin/affiliates" element={<Admin><Affiliates /></Admin>} />
              <Route path="/admin/content" element={<Admin><AdminContent /></Admin>} />
              <Route path="/admin/content-edit" element={<Admin><ContentEdit /></Admin>} />
              <Route path="/admin/crystals" element={<Admin><AdminCrystals /></Admin>} />
              <Route path="/admin/crystal-edit" element={<Admin><CrystalEdit /></Admin>} />
              <Route path="/admin/lab" element={<Admin><AdminLab /></Admin>} />
              <Route path="/admin/lab-edit" element={<Admin><LabEdit /></Admin>} />
              <Route path="/admin/lab-landing" element={<Admin><LabLanding /></Admin>} />
              <Route path="/admin/shopify" element={<Admin><Shopify /></Admin>} />
            </Routes>
          </BrowserRouter>
        </ProgressProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
